/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_OVER_VIEW_DETAILS_REQUEST,
  FETCH_OVER_VIEW_DETAILS_SUCCESS,
  FETCH_OVER_VIEW_DETAILS_FAILURE,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE,
} from "./OverViewDetailsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchOverViewDetailsRequest = () => {
  return {
    type: FETCH_OVER_VIEW_DETAILS_REQUEST,
  };
};

export const fetchOverViewDetailsDownloadRequest = () => {
  return {
    type: FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST,
  };
};

// Generic success action creator
const createSuccessAction = (actionType, payload) => ({
  type: actionType,
  payload,
});

export const fetchOverViewDetailsSuccess = (overviewDetails) =>
  createSuccessAction(FETCH_OVER_VIEW_DETAILS_SUCCESS, overviewDetails);

export const fetchOverViewDetailsDownloadSuccess = (overviewDetails) =>
  createSuccessAction(FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS, overviewDetails);

// Generic failure action creator
const createFailureAction = (actionType, error) => ({
  type: actionType,
  payload: error,
});

export const fetchOverViewDetailsFailure = (error) =>
  createFailureAction(FETCH_OVER_VIEW_DETAILS_FAILURE, error);

export const fetchOverViewDetailsDownloadFailure = (error) =>
  createFailureAction(FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE, error);

export const fetchOverViewDetails = ({
  isAppListNeeded,
  isCountNeeded,
  isAppCountNeeded,
  offset,
  limit,
  searchText,
  requestBody,
  download = false,
}) => {
  return async function (dispatch) {
    // Select appropriate action creators based on download flag
    const requestAction = download ? fetchOverViewDetailsDownloadRequest : fetchOverViewDetailsRequest;
    const successAction = download ? fetchOverViewDetailsDownloadSuccess : fetchOverViewDetailsSuccess;
    const failureAction = download ? fetchOverViewDetailsDownloadFailure : fetchOverViewDetailsFailure;

    dispatch(requestAction());
    try {
      const data = await APIManager.getOverViewData(
        isAppListNeeded,
        isCountNeeded,
        isAppCountNeeded,
        offset,
        limit,
        searchText,
        requestBody
      );
      dispatch(successAction(data));
    } catch (error) {
      dispatch(failureAction(error));
    }
  };
};

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};
